import { apiSelector } from '@ackee/redux-utils';

import type { RootState } from 'modules/core/modules/redux';
import { EntityKey } from 'modules/entities/constants';

import { CHECK_ADDRESS_DELIVERY_REDUCER_KEY } from '../constants';

export const selectCheckAddressDeliveryApi = (state: RootState) =>
    apiSelector(state, EntityKey.CUSTOMER_RETURN, CHECK_ADDRESS_DELIVERY_REDUCER_KEY);
